export default __webpack_public_path__ + "static/media/loanOffer_walking-person.746725a9.svg";